<template>
    <div class="ah-page accounting-relation-setting-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>會計科目對照表</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-tabs v-model="activePage" @tab-click="onClick">
                <el-tab-pane lazy label="收支項目" name="item">
                    <AccountingItemsRelationSettings />
                </el-tab-pane>
                <el-tab-pane label="銀行帳戶" name="bank">
                    <BankAccountingItemsRelationSettings />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import AccountingItemsRelationSettings from '@/components/dashboard/Accounting/AccountingRelationSetting/AccountingItemsRelationSettings.vue';
import BankAccountingItemsRelationSettings from '@/components/dashboard/Accounting/AccountingRelationSetting/BankAccountingItemsRelationSettings.vue';

export default {
    name: 'accounting-relation-setting',
    components: { AccountingItemsRelationSettings, BankAccountingItemsRelationSettings },
    data() {
        return {
            activePage: 'item',
        };
    },
    computed: {},
    methods: {
        onClick() {
            //
        },
    },
};
</script>

<style lang="scss">
</style>
